import React from 'react';
import PropTypes from 'prop-types';
import { Box, Paper, Typography } from '@esgian/esgianui';
import { getTransparentBackground } from '@helpers';
import { useSelector } from 'react-redux';
import { getThemeMode } from '@store/features';
import MultiSelectDropdown from '../../Common/MultiSelectDropdown';
import DashboardActivityMapDrawerHeader from '../DashboardActivityMap/Common/DashboardActivityMapDrawerHeader';

const VesselsMapFilter = ({ onClose, vessels, selectedVessels, onVesselSelectionChange }) => {
  const themeMode = useSelector(getThemeMode);

  const vesselOptions = React.useMemo(() => {
    return (vessels ?? []).map((vessel) => ({
      id: vessel.imo,
      name: vessel.vesselName || vessel.vessel_name
    }));
  }, [vessels]);

  const selectedOptions = React.useMemo(() => {
    return vesselOptions.filter((option) => selectedVessels?.includes(option.id));
  }, [vesselOptions, selectedVessels]);

  return (
    <Box height="100%" width={'20rem'}>
      <Paper
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          p: 2,
          backgroundColor: getTransparentBackground(themeMode),
          color: themeMode ? 'white' : 'black'
        }}>
        <DashboardActivityMapDrawerHeader title="Vessel Filter" onClose={onClose} />

        <Box>
          <Typography mb={1} color={themeMode ? 'white' : 'black'}>
            Select Vessels:
          </Typography>
          <MultiSelectDropdown
            handleChange={(selected) => {
              onVesselSelectionChange(selected.map((v) => v.id));
            }}
            placeholder="Select Vessels"
            selectedOptions={selectedOptions}
            options={vesselOptions}
            label="Vessels"
            width="100%"
          />
        </Box>
      </Paper>
    </Box>
  );
};

VesselsMapFilter.propTypes = {
  onClose: PropTypes.func.isRequired,
  vessels: PropTypes.arrayOf(
    PropTypes.shape({
      imo: PropTypes.number.isRequired,
      vesselName: PropTypes.string,
      vessel_name: PropTypes.string
    })
  ),
  selectedVessels: PropTypes.arrayOf(PropTypes.number),
  onVesselSelectionChange: PropTypes.func
};

export default VesselsMapFilter;
